import React, { useRef, useState, useEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import HeroThreeImg1 from "../assets/images/hero-banner-1.avif";
import HeroThreeImg2 from "../assets/images/hero-banner-2.avif";
import HeroThreeImg3 from "../assets/images/hero-banner-3.avif";
import HeroThreeImg4 from "../assets/images/hero-banner-4.avif";
import HeroThreeImgMobile1 from "../assets/images/aa-mobile.png";
import HeroThreeImgMobile2 from "../assets/images/aa-mobile-2.avif";
import HeroThreeImgMobile3 from "../assets/images/aa-mobile-3.avif";
import HeroThreeImgMobile4 from "../assets/images/aa-mobile-4.avif";
import "../styles/HeroThree.css";

const slides = [
    {
        project: "Serene Clubhouse",
        text: "Contemporary Villas Designed for a Serene Lifestyle",
        image: HeroThreeImg1,
        mobileImage: HeroThreeImgMobile1
    },
    {
        project: "Vessella Serene",
        text: "Elevating Everyday Living with World-Class Amenities",
        image: HeroThreeImg2,
        mobileImage: HeroThreeImgMobile2
    },
    {
        project: "Vessella Palms",
        text: "Experience Comfort, Style & Serenity",
        image: HeroThreeImg3,
        mobileImage: HeroThreeImgMobile3
    },
    {
        project: "Palms Clubhouse",
        text: "The Heart of Lifestyle and Community Living",
        image: HeroThreeImg4,
        mobileImage: HeroThreeImgMobile4
    }
];

export default function HeroThree() {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    // INTRO ANIMATIONS SCRIPT START
    const words = slides[currentSlide].text.trim().split(/\s+/);

    const container = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.18,   // slower word gap
                delayChildren: 0.4,      // calm start
            },
        },
    };

    const wordVariant = {
        hidden: {
            opacity: 0,
            y: 28,
            filter: "blur(12px)",
        },
        show: {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            transition: {
                duration: 1.1,          // slow reveal
                ease: [0.22, 1, 0.36, 1], // luxury easing
            },
        },
    };

    const projectVariant = {
        hidden: {
            opacity: 0,
            y: 20,
            filter: "blur(10px)",
        },
        show: {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            transition: {
                duration: 0.9,
                ease: [0.22, 1, 0.36, 1],
            },
        },
    };

    const imageVariant = {
        hidden: {
            opacity: 0,
            scale: 1.1,
            transition: {
                duration: 1.5,
                ease: [0.22, 1, 0.36, 1],
            }
        },
        show: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 2,
                ease: [0.22, 1, 0.36, 1],
            },
        },
    };

    const buttonVariant = {
        hidden: {
            opacity: 0,
            y: 30,
        },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.9,
                delay: 1.6, // after text animation
                ease: [0.22, 1, 0.36, 1],
            },
        },
    };

    // INTRO ANIMATIONS SCRIPT END




    const sectionRef = useRef(null);



    const { scrollYProgress } = useScroll({
        target: sectionRef,
        offset: ["start start", "end start"]
    });

    // Map scroll progress to opacity
    // const overlayOpacity = useTransform(
    //     scrollYProgress,
    //     [0, 0.25], 
    //     [0, 1]    
    // );

    const overlayOpacity = useTransform(
        scrollYProgress,
        [0.05, 0.4],  // start later, finish before exit
        [0, 1]
    );


    return (
        <section
            ref={sectionRef}
            className="hero-three position-relative"
        >
            {/* TEXT CONTENT */}
            <div className="container h-100 position-relative hero-content">
                <div className="row h-100">
                    <div className="col-lg-6 d-flex flex-column ">
                        <motion.p
                            key={`project-${currentSlide}`}
                            variants={wordVariant}
                            initial="hidden"
                            animate="show"
                            className="mb-2"
                        >
                            {slides[currentSlide].project}
                        </motion.p>
                        <motion.h1
                            key={currentSlide}
                            variants={container}
                            initial="hidden"
                            animate="show"
                            className="pertili-font pb-lg-5 pb- display-4 fw-lighter text-black mb-"
                        >
                            {words.map((wordText, i) => (
                                <motion.span
                                    key={i}
                                    variants={wordVariant}
                                    style={{ display: "inline-block", marginRight: "0.4em" }}
                                >
                                    {wordText}
                                </motion.span>
                            ))}
                        </motion.h1>


                    </div>
                </div>
            </div>

            {/* BACKGROUND IMAGE */}
            {slides.map((slide, index) => (
                <motion.img
                    key={`img-desktop-${index}`}
                    variants={imageVariant}
                    initial="hidden"
                    animate={currentSlide === index ? "show" : "hidden"}
                    className="hero-three-img position-absolute d-none d-md-block top-0 start-0 w-100 h-100 object-fit-cover"
                    src={slide.image}
                    alt=""
                />
            ))}

            {slides.map((slide, index) => (
                <motion.img
                    key={`img-mobile-${index}`}
                    variants={imageVariant}
                    initial="hidden"
                    animate={currentSlide === index ? "show" : "hidden"}
                    className="hero-three-img-mobile d-block d-md-none d-lg-none position-absolute bottom-0 start-0 w-100 h-50  object-fit-cover"
                    src={slide.mobileImage}
                    alt=""
                />
            ))}

            {/* GRADIENT OVERLAY */}
            <motion.div
                className="gradient-overlay-three"
                style={{ opacity: overlayOpacity }}
            />

            <button
                className="explore-btn"
                onClick={() =>
                    document
                        .getElementById("about-section")
                        .scrollIntoView({ behavior: "smooth" })
                }
            >
                <span className="explore-arrows">
                    <svg viewBox="0 0 4 8">
                        <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                    </svg>
                    <svg viewBox="0 0 4 8">
                        <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                    </svg>
                    <svg viewBox="0 0 4 8">
                        <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                    </svg>
                </span>

                <span className="explore-text geist-font">EXPLORE</span>
            </button>





        </section>

    );
}
